const SecondaryBtnLight = ({ title, css, onClick, type, leftIcon, rightIcon }: any) => {
    return (
        <button type={type} className={`flex items-center justify-center gap-[8px] xlx:gap-[15px] w-fit text-sm border border-[#6E7C87] text-[#6E7C87] rounded-[4px] h-[35px] xlx:h-[40px] focus:shadow-[0_0_0_3px_#6E7C875e] hover:shadow-[0_0_0_3px_#6E7C875e] ${css}`} onClick={onClick}>
            {!!leftIcon && leftIcon} {!!title && title}  {!!rightIcon && rightIcon}
        </button>
    );
};

export default SecondaryBtnLight;